import { ConfigModel } from '@bymason/controller-api-hooks';

export type StepId = 'apps' | 'splash' | 'bootanimation' | 'config' | 'review';

export interface StepView {
  label: string;
  description?: string;
  complete?: boolean;
  type: StepId;
}

export const stepViews: StepView[] = [
  {
    label: 'Apps',
    type: 'apps',
  },
  {
    label: 'Splash image',
    type: 'splash',
  },
  {
    label: 'Boot animation',
    type: 'bootanimation',
  },
  {
    label: 'Configure device',
    type: 'config',
  },
  {
    label: 'Review',
    type: 'review',
  },
];

export const getStepIndex = (stepId?: StepId) => {
  return stepViews.findIndex((view) => view.type === stepId);
};

export const getBaseProjectConfig = (projectId: string): ConfigModel => ({
  os: {
    name: projectId,
    version: 'latest',
  },
});

export enum ConfigActionTypes {
  ChangeApps = 'config-change-apps',
  ChangeSplash = 'config-change-splash',
  ChangeBootanimation = 'config-change-bootanimation',
  ChangeOsConfigurations = 'config-change-os-configurations',
  ReplaceConfig = 'config-replace-all',
}
interface ChangeAppsAction {
  type: ConfigActionTypes.ChangeApps;
  payload: ConfigModel['apps'];
}
type ChangeSplashAction = {
  type: ConfigActionTypes.ChangeSplash;
  payload: { name: string; version: number } | undefined;
};
type ChangeBootanimationAction = {
  type: ConfigActionTypes.ChangeBootanimation;
  payload: { name: string; version: number } | undefined;
};
type ChangeOsConfigurations = {
  type: ConfigActionTypes.ChangeOsConfigurations;
  payload: ConfigModel['os']['configurations'];
};
type ReplaceConfigAction = {
  type: ConfigActionTypes.ReplaceConfig;
  payload: ConfigModel;
};
type ConfigAction =
  | ChangeAppsAction
  | ChangeSplashAction
  | ChangeBootanimationAction
  | ChangeOsConfigurations
  | ReplaceConfigAction;
export const configReducer = (config: ConfigModel, action: ConfigAction) => {
  if (action) {
    switch (action.type) {
      case ConfigActionTypes.ChangeApps: {
        const newApps = action.payload;
        return {
          ...config,
          apps: newApps && newApps.length > 0 ? newApps : undefined,
        };
      }
      case ConfigActionTypes.ChangeSplash: {
        const newMedia = {
          ...config.media,
          splash: action.payload,
        };
        return {
          ...config,
          media: newMedia.bootanimation || newMedia.splash ? newMedia : undefined,
        };
      }
      case ConfigActionTypes.ChangeBootanimation: {
        const newMedia = {
          ...config.media,
          bootanimation: action.payload,
        };
        return {
          ...config,
          media: newMedia.bootanimation || newMedia.splash ? newMedia : undefined,
        };
      }
      case ConfigActionTypes.ChangeOsConfigurations: {
        const newConfigurations = action.payload;
        return {
          ...config,
          os: {
            ...config.os,
            configurations:
              newConfigurations && Object.keys(newConfigurations as Record<string, string>).length
                ? newConfigurations
                : undefined,
          },
        };
      }
      case ConfigActionTypes.ReplaceConfig: {
        const newConfig = action.payload;
        return {
          ...newConfig,
        };
      }
    }
  }

  return config;
};
